import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { Box } from "@material-ui/core";
import { Help } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useStyles } from "./styles";

function ClaimStatus({ classes: { statusButton, question }, handleRemarksClick, item }) {
  return (
    <>
      <Box
        display={"flex"}
        className={`${statusButton} ${item?.status_slug}`}
        data-tip={item?.rejection_reason}
      >
        {item?.status_text}
        {item?.rejection_reason && (
          <>
            <Help style={{ height: "20px" }} />
            <ReactTooltip html={true} />
          </>
        )}
      </Box>
      {item?.claim_remarks.length > 0 && (
        <Box display={"flex"} onClick={() => handleRemarksClick(item)} style={{ color: "#3c63fc"}}>
          <VisibilityIcon style={{ height: "20px" }} /> Remarks
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(ClaimStatus);
